export default __webpack_public_path__ + "static/media/vending_machine_mangmnt_orange.5efef355.svg";